export default {
    getLoading({ loading }){
        return loading
    },

    getAlert({ alert }){
        return alert
    }
}
